import  React,{Component} from 'react'
import {Link} from 'react-router-dom'
import {teamsData} from '../data/teamsData'
import List from '../components/List'
import axios from 'axios'
import {getDomain,getCall} from '../components/common/domain'



class jobsListItem extends Component{
    render(){
        const {_id,name,locations} = this.props.itemData
        return <li key={_id}>
            <Link to={{ pathname: `/career/`, search: `view=job_description&id=${_id}`}}>
            <div className={'name'}>{name}</div>
            <div className={'location'}>{locations.toString()}</div>
            <div className={'view'}>View</div>
            </Link>
        </li>
    }
}

class positionListItem extends Component{
    render(){
        const {id,jobsList,name} = this.props.itemData
        return <li key={id}>
            <div className={'team-name'}>{name}</div>
            <List items={jobsList} listItem={jobsListItem} className={'job-list'}/>
        </li>
    }
}


class TeamsListItem extends Component{
    render(){
        const {id,platforms,department} = this.props.itemData
        return <li key={id}>
            <div className={'department-name'}>{department}</div>
            <List items={platforms} listItem={positionListItem} className={'team-list'}/>
        </li>
    }
}
export default class OpenPosition extends Component{
    state={
        teamsData:[]
    }
    getOptions(){
        this.setState({
            loading:true
        })
        getCall(`/hubbler/open-positions/`).then(res=>{
            if(res.data.success){
                this.setState({
                    teamsData:res.data.result,
                    loading:false
                })
            }else {
                alert(res.data.error)
            }
        })

    }
    componentDidMount(){
        this.getOptions()
    }
    render (){
        return <div className={'open-position-view'}>
            <div className={'header-list'}>
                <Link to={'/career'}>Careers</Link>
                /
                <Link to={{ pathname: `/career/`, search: `view=openPositions`}}>Open Positions</Link>
            </div>
            <div className={'head'}>Open Positions</div>
            {this.state.loading ? <div className={'loading'}></div> :
            <List items={this.state.teamsData} listItem={TeamsListItem} className={'department-list'}/>}
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/OpenPosition.js